// extracted by mini-css-extract-plugin
export default {"mask":"DmTFySBcGgwUXOzhdw_r","closableMask":"U9aWa2UVtGZxZWIKgW5Q","wrapper":"otjU9eWSbnTy8iG54Kwz","modalCloseBtn":"SbkEYCKvOmX6XvEWCTTs"};